import { loadableReady } from '@loadable/component';
import renderApp from './renderApp';
function render() {
    renderApp();
}
loadableReady(() => {
    render();
});
